
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import NewWfDetailPop from '@xt/www/components/newWfDetailPop/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import EmptyView from './EmptyView.vue'
import { Observer } from 'mobx-vue'

type Wenfang = {
  id: number
  coverUrl: string
  appletUrl: string
  toolName: string
  description: string
  request?: boolean
}

@Observer
@Component({
  components: {
    LazyImg,
    NewWfDetailPop,
    EmptyView
  }
})
export default class extends Vue {
  wfPopupShow: boolean = false
  wfDetail: Wenfang | null = null

  get productTools() {
    return this.$store.$courseV2.productInfo?.productTools ?? []
  }

  stopPropagation(e) {
    e.stopPropagation()
  }

  openWfPopup(item: Wenfang) {
    this.wfDetail = {
      ...item,
      request: true
    }
    this.showWfPopup(true)
  }

  showWfPopup(isShow: boolean) {
    this.wfPopupShow = isShow
  }

  @Emit('back')
  backGuide() {}

  @Emit('exit')
  handleExit() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
